module.exports = __webpack_public_path__ + "img/background.8ef4b47a.png";